import { buildBandColumnKey, joinRegistryWithTariffs } from "./matrixAdapters";

const normalizeComparableValue = (value) => (value == null ? "" : String(value));

const buildVisibleCells = ({ cells = {}, bands = [], dirtyChanges = {} }) => {
  const bandKeys = bands.map((band) => band.columnKey || buildBandColumnKey(band));
  const visibleKeys = bandKeys.length
    ? Array.from(new Set([...bandKeys, ...Object.keys(cells), ...Object.keys(dirtyChanges)]))
    : Array.from(new Set([...Object.keys(cells), ...Object.keys(dirtyChanges)]));

  return visibleKeys.reduce((accumulator, columnKey) => {
    const cell = cells[columnKey] || {};
    const dirtyCell = dirtyChanges[columnKey];

    accumulator[columnKey] = dirtyCell
      ? {
          ...cell,
          draftPrice: dirtyCell.price,
        }
      : {
          ...cell,
        };

    return accumulator;
  }, {});
};

export const buildVisibleTariffRows = ({
  registryRows = [],
  tariffRows = [],
  bands = [],
  dirtyRowsById = {},
}) => {
  const baseRows = joinRegistryWithTariffs({
    registryRows,
    tariffRows,
  });

  return baseRows.map((row) => {
    const dirtyRow = dirtyRowsById[row.crossDockingPointId];

    return {
      ...row,
      cells: buildVisibleCells({
        cells: row.cells,
        bands,
        dirtyChanges: dirtyRow?.changes || {},
      }),
    };
  });
};

export const buildNextDirtyRowsById = (current, row, columnKey, value) => {
  const cell = row?.cells?.[columnKey] || {};
  const existingDirtyRow = current[row.crossDockingPointId] || {
    crossDockingPointId: row.crossDockingPointId,
    kato: row.kato,
    changes: {},
  };

  const nextChanges = {
    ...existingDirtyRow.changes,
    [columnKey]: {
      id: cell.id,
      price: value,
      updatedAt: cell.updatedAt,
    },
  };

  if (normalizeComparableValue(value) === normalizeComparableValue(cell.price)) {
    delete nextChanges[columnKey];
  }

  if (!Object.keys(nextChanges).length) {
    const nextState = { ...current };
    delete nextState[row.crossDockingPointId];
    return nextState;
  }

  return {
    ...current,
    [row.crossDockingPointId]: {
      ...existingDirtyRow,
      changes: nextChanges,
    },
  };
};
